import React, { useState, useEffect } from "react";
import { Table, Modal, Form, Col, Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { useHistory } from "react-router-dom";
import SVG from "react-inlinesvg";
import { useAlert } from "react-alert";
import { baseUrl } from "../../../services/config";
import CustomChallanModal from "./customChallanModal";
import DropDownCheckboxModal from "./dropdownModalwithCheckbox";
const CustomChallan = () => {
  const history = useHistory();
  const authtoken = localStorage.getItem("userToken");
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const alert = useAlert();
  const [campuses, setallcampuses] = useState([]);
  const [students, setstudents] = useState([]);
  const [fee_types, setfee_types] = useState([]);
  const [fee_type_id, setfee_type_id] = useState("");
  const [challangenerateModal, setchallangenerateModal] = useState(false);
  const [selectedStudent, setselectedstudent] = useState({});
  const [due_date, setdue_date] = useState("");
  const [selectedfeetypes, setselectedfeetypes] = useState(null);
  const [issue_date, setissue_date] = useState("");
  const [loading, setloading] = useState(false);

  useEffect(() => {
    getAllCampus();
    getFeeTypes();
  }, []);

  const getAllCampus = async () => {
    await fetch(`${baseUrl}/campus`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setallcampuses(data.payload);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getFeeTypes = () => {
    fetch(`${baseUrl}/feestypes`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => {
        res.json().then((data) => {
          setfee_types(data.payload);
        });
      })
      .catch((err) => {
        alert.error(err);
      });
  };

  const getAllStudents = async (id) => {
    setloading(true);
    await fetch(`${baseUrl}/campus/campus-students/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${authtoken}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setstudents(data.payload);
        setloading(false);
        // dispatch({
        //   type: 'GET_ALL_STUDENT',
        //   payload: data.payload
        // })
      })
      .catch((err) => {
        console.log(err);
        setloading(false);
      });
  };

  const openmodal = (student) => {
    setselectedstudent(student);
    setchallangenerateModal(true);
  };

  const generateCustomChallan = () => {
    const data = {
      fee_type_id: selectedfeetypes,
      student_id: selectedStudent.id,
      due_date,
      issue_date,
    };
    console.log(data);
    // fetch(`${baseUrl}/custom_fee_generate`, {
    //     method: 'POST',
    //     headers: {
    //         'Accept': 'application/json',
    //         'Content-Type': 'application/json',
    //         'Authorization': `Bearer ${authtoken}`
    //     },
    //     body: JSON.stringify(data)
    // })
    //     .then((res) => {
    //         res.json()
    //             .then((data) => {
    //                 // console.log(data)
    //                 if (data.metadata.success) {
    //                     alert.show('Challan Generated')
    //                     setchallangenerateModal(false)
    //                     history.push('/campusfeechallan')

    //                 }
    //             })
    //     })
    //     .catch(err => {
    //         setchallangenerateModal(false)
    //         alert.show('Somthing went Wrong', err)
    //         console.log(err)
    //     })
  };

  return (
    <div>
      <div
        style={{
          margin: 10,
        }}
        className="form-group col-sm-12 flex-column d-flex"
      >
        <select
          onChange={(e) => getAllStudents(e.target.value)}
          className="form-select"
          style={{ backgroundColor: "#F3F6F9", height: 40 }}
          aria-label="Default select example"
        >
          <option selected disabled>
            Select Campus
          </option>
          {campuses.map((campus) =>
            user.head_office.id == campus.head_office_id ? (
              <>
                <option value={campus.id}>{campus.name}</option>
              </>
            ) : null
          )}
          {/* {
                        campuses.map(clas => (
                            <option value={clas.id}>{clas.name}</option>
                        ))
                    } */}
        </select>
      </div>

      <Table responsive>
        <thead>
          <tr>
            <th>Student Name</th>
            <th>Student className</th>
            <th>Admission_id</th>
            <th>Make Custom Challan</th>
          </tr>
        </thead>
        <tbody>
          {students.map((student) => (
            <tr>
              <td className="text_align_start padding_left">{student.name}</td>
              <td className="text_align_start padding_left">
                {student.student_class_name}
              </td>
              <td className="text_align_start padding_left">
                {student.admission_id}
              </td>
              <td className="text_align_start padding_left">
                <button>
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => openmodal(student)}
                    className="svg-icon svg-icon-md svg-icon-primary"
                  >
                    <SVG
                      src={toAbsoluteUrl(
                        "/media/svg/icons/Devices/Printer.svg"
                      )}
                    />
                  </span>
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <div className="row justify-content-center">
        {loading && (
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
      </div>

      <CustomChallanModal
        fee_types={fee_types}
        selectedStudent={selectedStudent}
        show={challangenerateModal}
        onHide={() => setchallangenerateModal(false)}
      />

      {/* <Modal show={challangenerateModal} size="lg">
                <Modal.Header>
                    <h1>Generate Custom challan</h1>
                </Modal.Header>

                <Modal.Body>
                    <form>
                        <div className="row justify-content-between text-left" >

                            <div className="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                    <b>Student Name</b>
                                </label>
                                <input disabled defaultValue={selectedStudent.name} className="form-control placeholder-bg mb-2" />

                                <label className="form-control-label">
                                    <b>Addmission Id</b>
                                </label>
                                <input disabled defaultValue={selectedStudent.admission_id} className="form-control placeholder-bg mb-2" />
                            </div>

                        </div>


                         <DropDownCheckboxModal fee_types={fee_types} selectedfeetypes={() => setselectedfeetypes()} />
                                 */}

      {/* <div className="form-group col-sm-6 flex-column d-flex pt-3">

                            <label className="form-control-label">
                                <b>Select Fee types</b>
                            </label>
                            <Form.Group as={Col} controlId="my_multiselect_field">
                                <Form.Label>Select Classes</Form.Label>
                                <Form.Control as="select" multiple value={selectedfeetypes}
                                    onChange={e => {
                                        // console.log("SElected DAta", e.target.selectedOptions);
                                        setselectedfeetypes([].slice.call(e.target.selectedOptions).map(item => item.value))
                                    }}>
                                    {
                                        fee_types.map((cls, i) => {
                                            return (
                                                <option value={cls.id}>{cls.name}</option>
                                            )
                                        })

                                    }

                                </Form.Control>
                            </Form.Group> */}

      {/* { <select
                                onChange={(e) => setfee_type_id(e.target.value)}
                                className="form-select"
                                style={{ backgroundColor: '#F3F6F9', height: 40 }}
                                aria-label="Default select example"
                            >
                                <option selected disabled>
                                    Select Fee Type
                                </option>

                                {
                                    fee_types.map(fee => (
                                        <option value={fee.id}>{fee.name}</option>
                                    ))
                                }


                           </select> } */}

      {/* <h6 style={{ paddingLeft: 20, margin: 30, color: 'blueviolet' }}>Selected Fee Types</h6>

                            <ol>
                                {
                                    selectedfeetypes.map((person) => {
                                        return (

                                            <li key={person.id}>{person.name}</li>

                                        )
                                    })
                                }
                            </ol>
                        </div> */}

      {/* <div className="row justify-content-between text-left" >

                            <div className="form-group col-sm-6 flex-column d-flex">
                                <label className="form-control-label">
                                    <b>Due Date</b>
                                </label>
                                <input onChange={(e) => setdue_date(e.target.value)} type="date" className="form-control placeholder-bg mb-2" />

                                <label className="form-control-label">
                                    <b>Issue Date</b>
                                </label>
                                <input onChange={(e) => setissue_date(e.target.value)} type="date" className="form-control placeholder-bg mb-2" />
                            </div>

                        </div>
                    </form>

                </Modal.Body>
                <Modal.Footer>
                    <button
                        onClick={generateCustomChallan}
                        className="btn btn-success button_blue">
                        Generate
                    </button>
                    <button
                        onClick={() => setchallangenerateModal(false)}
                        className="btn btn-danger btn_width">
                        Cancel
                    </button>
                </Modal.Footer>
            </Modal> */}
    </div>
  );
};

export default CustomChallan;
